// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"c50e0792","592":"59275b69","856":"334a0fe5"}[chunkId] + ".chunk.js";
};